import { render, staticRenderFns } from "./Manne.vue?vue&type=template&id=1284b0d8&"
import script from "./Manne.vue?vue&type=script&lang=js&"
export * from "./Manne.vue?vue&type=script&lang=js&"
import style0 from "./Manne.vue?vue&type=style&index=0&id=1284b0d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports